var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "column-filter-list-modal",
        size: "reference",
        centered: "",
        "hide-footer": "",
        "hide-header": "",
      },
      on: { close: _vm.close },
      model: {
        value: _vm.active,
        callback: function ($$v) {
          _vm.active = $$v
        },
        expression: "active",
      },
    },
    [
      _c("svg-icon", {
        staticClass: "modal-dialog__close",
        attrs: { name: "times-bold", size: 8 },
        on: { click: _vm.close },
      }),
      _c("div", { staticClass: "m-column-filters" }, [
        _c("div", { staticClass: "m-column-filters__wrapper" }, [
          _c(
            "div",
            { staticClass: "m-column-filters__item" },
            [
              _c("c-input", {
                staticClass: "m-column-filters__condition",
                attrs: { type: "select", size: "small", items: _vm.conditions },
                model: {
                  value: _vm.condition,
                  callback: function ($$v) {
                    _vm.condition = $$v
                  },
                  expression: "condition",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "m-column-filters__item m-column-filters__item_value",
            },
            [
              _c("c-input", {
                staticClass:
                  "m-column-filters__value m-column-filters__value_select",
                attrs: {
                  type: "select",
                  size: "small",
                  items: _vm.list,
                  multiple: true,
                  searchable: true,
                  placeholder: "Выберите значение",
                },
                model: {
                  value: _vm.value,
                  callback: function ($$v) {
                    _vm.value = $$v
                  },
                  expression: "value",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "m-column-filters__actions" },
            [
              _c("c-button", {
                staticClass: "m-column-filters__action",
                attrs: {
                  tooltip: "Применить фильтр по столбцу",
                  size: "small",
                  icon: { icon: "check", color: "success" },
                },
                on: { click: _vm.apply },
              }),
              _c("c-button", {
                staticClass: "m-column-filters__action",
                attrs: {
                  tooltip: "Отменить фильтр по столбцу",
                  size: "small",
                  icon: { icon: "close", color: "secondary" },
                },
                on: { click: _vm.reset },
              }),
              _c("c-button", {
                staticClass: "m-column-filters__action_mobile",
                attrs: { color: "white", label: "Сбросить" },
                on: { click: _vm.reset },
              }),
              _c("c-button", {
                staticClass: "m-column-filters__action_mobile",
                attrs: { color: "primary", label: "Применить" },
                on: { click: _vm.apply },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }